import React, { useEffect, useState } from "react";
import { getConversationTranscript } from "../../services/conversationTranscriptApi";
import "./ConversationTranscript.css";

const ConversationTranscript = ({
  conversationId,
  messages = [],
}) => {
  const [transcript, setTranscript] = useState([]);
  const [status, setStatus] = useState("idle");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (!conversationId) {
      setTranscript([]);
      setStatus("empty");
      return;
    }

    const loadTranscript = async () => {
      setStatus("loading");
      setErrorMessage("");

      try {
        const response = await getConversationTranscript(
          conversationId,
          messages
        );

        if (response.success) {
          setTranscript(response.data || []);

          if (response.data && response.data.length > 0) {
            setStatus("success");
          } else {
            setStatus("empty");
          }
        }
      } catch (error) {
        setStatus("error");
        setErrorMessage(
          "Failed to load conversation transcript."
        );
      }
    };

    loadTranscript();
  }, [conversationId, messages]);

  const getMessageClass = (from) => {
    if (from === "visitor") {
      return "transcript-message visitor-message";
    }

    if (from === "agent") {
      return "transcript-message agent-message";
    }

    if (from === "bot") {
      return "transcript-message bot-message";
    }

    return "transcript-message system-message";
  };

  return (
    <div className="conversation-transcript">

      {/* Header */}
      <div className="transcript-header">
        <h3>Conversation Transcript</h3>
        <span>Live conversation</span>
      </div>

      {/* Loading */}
      {status === "loading" && (
        <div className="transcript-state">
          Loading conversation...
        </div>
      )}

      {/* Empty */}
      {status === "empty" && (
        <div className="transcript-state">
          No conversation messages yet.
        </div>
      )}

      {/* Error */}
      {status === "error" && (
        <div className="transcript-error">
          {errorMessage}
        </div>
      )}

      {/* Transcript */}
      {status === "success" && (
        <div className="transcript-list">
          {transcript.map((message, index) => (
            <div
              key={message.id || index}
              className={getMessageClass(message.from)}
            >
              <div className="message-sender">
                {message.from === "visitor"
                  ? "Visitor"
                  : message.from === "agent"
                  ? "Agent"
                  : message.from === "bot"
                  ? "AI"
                  : "System"}
              </div>

              <div className="message-text">
                {message.text}
              </div>

              {message.createdAt && (
                <div className="message-time">
                  {message.createdAt}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

    </div>
  );
};

export default ConversationTranscript;